import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=da537dd8&scoped=true"
import script from "./LayoutTabs.vue?vue&type=script&lang=js"
export * from "./LayoutTabs.vue?vue&type=script&lang=js"
import style0 from "./LayoutTabs.vue?vue&type=style&index=0&id=da537dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da537dd8",
  null
  
)

export default component.exports